import http from "../http-common";
import { TabModel } from "../models/tabModel";

class TabDataService {
  async createTab(tab: TabModel) {
    const json = JSON.stringify(tab);
    return await http.post("/tabs/create", json);
  }

  async updateTab(tab: TabModel) {
    const json = JSON.stringify(tab);
    return await http.post("/tabs/update", json);
  }

  async deleteTabs(tabs: TabModel[]) {
    const json = JSON.stringify(tabs);
    return await http.post("/tabs/delete", json);
  }

  async copyTabs(tabs: TabModel[]) {
    const json = JSON.stringify(tabs);
    return await http.post("/tabs/copy", json);
  }
}

export default new TabDataService();